export default "__VITE_ASSET__Z$a3kSBa__"